import { gql } from '@apollo/client';

export const CLAIM_ACCOUNT = gql`
  mutation bauLogin($username: String!, $password: String!, $instance: String!, $migratedAccountID: Float!) {
    bauLogin(
      input: { username: $username, password: $password, instance: $instance, migratedAccountID: $migratedAccountID }
    )
  }
`;
